import { render, staticRenderFns } from "./NeoparentHospital.vue?vue&type=template&id=23ddcf0b&scoped=true"
import script from "./NeoparentHospital.vue?vue&type=script&lang=js"
export * from "./NeoparentHospital.vue?vue&type=script&lang=js"
import style0 from "./NeoparentHospital.vue?vue&type=style&index=0&id=23ddcf0b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ddcf0b",
  null
  
)

export default component.exports